/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {HISTORY_EVENT_ICON_BY_ASSET} from '../maps/constants';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Stop Icon component.
 */
export const HarshEventIcon = (props: IconProps) => {
  const {iconSize}   = useIconDLS(props);
  const {harshEvent} = HISTORY_EVENT_ICON_BY_ASSET;

  return (
    <ThemeIconProvider name='HarshEventIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' transform='matrix(0 1 -1 0 0 -0)' xmlns='http://www.w3.org/2000/svg'>
        <path fillRule='evenodd' clipRule='evenodd' d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37563 18.6244 0.00734817 12 0Z' fill='white'/>
        <path fillRule='evenodd' clipRule='evenodd' d='M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9938 17.5203 17.5203 21.9938 12 22V22Z' fill={harshEvent.color}/>
        <path fillRule='evenodd' clipRule='evenodd' d='M12 4L7 18L12 14.6667L17 18L12 4Z' fill='white'/>
      </svg>
    )} />
  );
};
